import { GetCitations, ModelType } from '@livv/models';
import groupBy from 'lodash/groupBy';
import useTranslation from 'next-translate/useTranslation';
import { FC } from 'react';
import CitationsForModelType from './CitationsForModelType';

interface CitationsProps {
    citationsOutput?: GetCitations['output'];
}

const Citations: FC<CitationsProps> = ({ citationsOutput }) => {
    const { lang } = useTranslation();

    if (!citationsOutput || citationsOutput.status === 'error') {
        return null;
    }

    const { citations, bookTitlesByPublicationSheet } = citationsOutput;

    const citationsGroupedByModelType = groupBy(
        citations.filter(({ source }) => source.type !== ModelType.STATISTIC), // statistic entries already displayed
        'source.type',
    );

    const sortedCitations = Object.entries(citationsGroupedByModelType).sort(
        ([modelTypeA], [modelTypeB]) => modelTypeA.localeCompare(modelTypeB, lang),
    );

    return (
        <>
            {sortedCitations.map(([modelType, modelCitations]) => (
                <CitationsForModelType
                    key={`citations-${modelType}`}
                    bookTitlesByPublicationSheet={bookTitlesByPublicationSheet}
                    citations={modelCitations}
                    modelType={modelType as ModelType}
                />
            ))}
        </>
    );
};

export default Citations;
